<div role="dialog" aria-labelledby="dialogTitle" class="refresh-modal">
  <div class="modal-header">
    <h2 id="dialogTitle" class="modal-title module-title">{{"refresh.prompt.title"|translate}}</h2>
  </div>
  <div class="modal-body">
    <p> {{ (tokenMinutesUntilExpiration == 1) ? ("refresh.prompt.minute" | translate:paramMinutesUntilExpiration) : ("refresh.prompt.minutes" | translate:paramMinutesUntilExpiration) }}
      {{ "refresh.prompt.message" | translate }}
    </p>

    <div class="modal-buttons">
      <breeze-button buttonText="{{'refresh.prompt.log.out'|translate}}"
                     id="log-out-btn"
                     [isSecondary]="true"
                     [isDisabled]="false"
                     (clicked)="logout()"></breeze-button>
      <breeze-button buttonText="{{'refresh.prompt.continue'|translate}}"
                     id="continue-btn"
                     [isPrimary]="true"
                     [isDisabled]="false"
                     (clicked)="continue()"></breeze-button>

    </div>
  </div>
</div>
